import Card from "./card";
import SectionTitle from "./section-title";
import Container from "./container";
import SectionWithBg from "./section-bg";
import { Link } from "react-router-dom";

// bg-urban_section_bg bg-no-repeat bg-top bg-cover bg-opacity-50

const Section = ({ title, data, id }) => {
  console.log("Id ", id);
  return (
    <SectionWithBg>
      <div id={id} className="w-full  py-8 md:py-14 ">
        <Container className={"space-y-12 md:space-y-16"}>
          <SectionTitle title={title} />
          <div className="grid grid-cols-1 md:grid-cols-2  gap-x-5 gap-y-8 md:gap-y-16">
            {data.map((item, idx) => {
              return item?.link ? (
                <Link to={item.link} id={item?.id}>
                  <Card key={idx} data={item} />
                </Link>
              ) : (
                <Card key={idx} data={item} />
              );
            })}
          </div>
        </Container>
      </div>
    </SectionWithBg>
  );
};

export default Section;
